const TIERS = [
  [900, 'Excellent'],
  [800, 'Very Good'],
  [670, 'Good'],
  [500, 'Fair'],
  [0, 'Poor'],
];

const TIER_STYLE = {
  Excellent: { bg: '#ECFDF5', border: '#6EE7B7', text: '#065F46' },
  'Very Good': { bg: '#ECFDF5', border: '#6EE7B7', text: '#065F46' },
  Good: { bg: '#EFF6FF', border: '#93C5FD', text: '#1E40AF' },
  Fair: { bg: '#FEFCE8', border: '#FDE047', text: '#854D0E' },
  Poor: { bg: '#FEF2F2', border: '#FCA5A5', text: '#991B1B' },
};

export const getTierForScore = score => {
  const tier = (TIERS.find(t => score >= t[0]) || TIERS[4])[1];
  return { label: tier, ...TIER_STYLE[tier] };
};
